module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-top-metals-remnants.3d377e8b.png";